// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aa17509c","239":"7297edea","318":"044132b9","455":"285cc125","464":"3270b8a9","533":"c65c95cd","781":"11255574","879":"12851242","991":"5d7f1c8e"}[chunkId] + ".chunk.js";
};